// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2a776732","455":"47c6d152","977":"7d91246c"}[chunkId] + ".chunk.js";
};